//import Sieves from './screens/index.vue';
const Sieves = () => import('./screens/index.vue')

import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const sievesRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.SIEVE_VIEW,
    PERMISSIONS_KEYS.SIEVE_INSERT,
    PERMISSIONS_KEYS.SIEVE_EDIT,
  ])
) {
  sievesRoutes.push({
    path: '/regras-da-prescricao/crivos',
    name: 'Administração|Crivo',
    component: Sieves,
    meta: {
      icon: 'fa-cog',
      requiresAuth: true,
    },
  });
}

export { sievesRoutes };
